import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
        detail: {},
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/views/projects/index.js